import { useEffect, useState } from "react";
import Header from "./Header";
import candy from "./Assets/images/Hero.png";
import { Link } from "react-router-dom";
import AboutUs from "./Homepage/AboutUs";
import Skills from "./Homepage/Skills";
import WhyYour from "./Homepage/WhyYour";
import Footer from "./Footer";

function Homepage() {
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    const savedMode = localStorage.getItem("theme");
    const systemPreference = window.matchMedia("(prefers-color-scheme: dark)").matches;
    if (savedMode === "dark" || (!savedMode && systemPreference)) {
      document.documentElement.classList.add("dark");
      setDarkMode(true);
    }
  }, []);

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
    if (!darkMode) {
      document.documentElement.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      document.documentElement.classList.remove("dark");
      localStorage.setItem("theme", "light");
    }
  };
  return (
    <>
      <Header darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
      <div className=" w-full flex  justify-center items-center h-fit pt-[128px] 100:px-[40px] sm:px-[64px]">
        <div className=" w-full flex flex-col justify-between items-center h-[550px]">
          <div className=" flex flex-col 100:w-[95%] md:w-fit justify-start items-center ">
            <div className="flex section flex-col 100:w-full md:w-fit 100:justify-center md:justify-start items-center">
              <div
                className={` 100:w-[85%] 100:gap-1  phone:gap-4 100:flex-col phone:flex-row  md:w-[425px] 100:justify-center md:justify-between items-center inline-flex ${
                  darkMode ? "text-[#f5f6f6]" : "text-[#25282b]"
                } text-[64px] font-normal italic font-instruement`}
              >
                <span>I’m a</span> <span className=" text-[#ffb600]">Product</span>
              </div>
              <div className={`100:w-full  md:w-[647px] 100:justify-center  md:justify-between 100:items-center mmd:items-start inline-flex ${darkMode ? "text-[#2F45FF]" : "text-[#0c0eff]"} md:text-8xl 100:text-6xl font-bold font-inter uppercase`}>
                <span>Desi</span>
                <span>gner</span>
              </div>
            </div>
            <div className=" flex flex-col justify-start items-center  md:mt-[-160px] md:ml-[-70px]">
              <img className=" z-10 100:w-full sm:w-[322px]" src={candy} alt="Candy" />
              <div className="mt-[-80px] inset-0 z-20">
                <Link className="" onClick={() => window.scrollTo(0, 0)} to="/contact">
                  <div className={`h-[43px] px-[25px] hover:bg-[#fd992f]  py-[5px] bg-[#ffb600] rounded-3xl shadow-customWhite justify-center items-center gap-2.5 inline-flex`}>
                    <div className="text-[#25282b] text-lg font-medium font-inter capitalize">Get In Touch</div>
                  </div>
                </Link>
              </div>
            </div>
          </div>
          <div className=" z-10 100:w-full 2xl:w-[1312px] 100:mt-[35px] 100:gap-[24px] xl:gap-0 xl:mt-[-140px] 100:flex-col xl:flex-row flex justify-between items-start">
            <div className="xl:w-[463px] project-card 100:w-full flex-col justify-start items-start gap-2.5 inline-flex">
              <div className={`h-0.5 w-full ${darkMode ? "bg-[#ccd2d5]" : "bg-[#393c40]"}`} />
              <div className={` ${darkMode ? "text-[#ccd2d5]" : "text-[#393c40]"} text-xl font-medium font-inter  capitalize leading-loose`}>
                Product Designer & Frontend Developer Specializing in Creating Innovative User Experiences and Designing Intuitive Interfaces
              </div>
            </div>
            <div className={`md:w-[378px] project-card 100:w-full ${darkMode ? "text-[#a9b2b7]" : "text-[#637077]"} text-base font-medium font-inter leading-[25px]`}>
              Bringing ideas to life from concept to code with seamless designs and cutting-edge frontend development, ensuring functionality and user engagement at every step.
            </div>
          </div>
        </div>
      </div>
      <AboutUs darkMode={darkMode} />
      <Skills darkMode={darkMode} />
      <WhyYour darkMode={darkMode} />
      <Footer darkMode={darkMode} />
    </>
  );
}

export default Homepage;
